<span *ngIf="!showLessMinute; else minTitleRef">{{ time }}</span>
<ng-template #minTitleRef>
  <span>{{ minTitle | customLocale }}</span>
</ng-template>

